import React, { Component } from 'react'
import { connect } from 'react-redux'

// Actions
import { getOrder, resetOrder } from '../../../../actions/orders'

// Components
// import WorkCard from '../../../Orders/Order/WorkCard'
import WorkCard from '../../../Orders/Order/NewWorkCard'

// Utils
import { translation } from '../../../../utils/helpers'
import { hasSubscriptionPermission } from '../../../../utils/auth'

class MyOrdersOrder extends Component {

  constructor (props) {
    super(props)
    this.state = {

    }
    this.onUpdateOrder = this.onUpdateOrder.bind(this)
  }

  componentDidMount () {
    this.props.getOrder(this.props.params.orderID)
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.params.orderID !== this.props.params.orderID) {
      this.props.resetOrder()
      this.props.getOrder(nextProps.params.orderID)
    }
  }

  onUpdateOrder () {
    return null
  }

  render () {
    if (!hasSubscriptionPermission(this.props.auth, 20)) return null
    return (
      <div className='order__screen'>
        <div className='order__screen--inner'>
          <div className='myOrders__workcard'>
            <WorkCard disabled onUpdateOrder={this.onUpdateOrder} router={this.props.router} renderTitles={[translation('159')]} />
          </div>
        </div>
      </div>
    )
  }
}
  // <WorkCard disabled onUpdateOrder={this.onUpdateOrder} renderTitles={translation('159')} />

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getOrder,
  resetOrder
})(MyOrdersOrder)



// WEBPACK FOOTER //
// ./src/app/pages/MyPage/MyOrders/Order/index.js